import ColorButton from 'components/Widget/Button/ColorButton';
import { IconType } from 'components/Icon';
import { interceptIfNoCredits } from 'economy';

interface CtaButtonProps {
	minimal: boolean; // if true show a very narrow version of the button
}

const CtaButton = ({ minimal = false }: CtaButtonProps) => {
	return (
		<ColorButton
			label={minimal ? '' : 'Try Moonchild'}
			icon={IconType.MOONCHILD}
			color="purple"
			size={minimal ? 'small' : 'default'}
			onClick={() => interceptIfNoCredits({ kind: 'tryMoonchild' })}
		/>
	);
};

export default CtaButton;
